import React from 'react';
import Lottie from 'lottie-react';
import animationData from './loading-animation.json';
import { cn } from '@/lib/utils';

interface LoadingProps {
    className?: string;
    size?: number;
}

const Loading: React.FC<LoadingProps> = ({ className, size = 200 }) => {
    return (
        <div className={cn('flex justify-center items-center h-screen w-full', className)}>
            <div style={{ width: size, height: size }}>
                <Lottie animationData={animationData} loop={true} />
            </div>
        </div>
    );
};

export default Loading;
